<template>
    <div class="qclist">
        <big-img v-if="showImg" :img-src="imgSrc" @clickit="viewImg" />
        <div class="clearfix qcnav">
            <NavBar
                class="restclass"
                :title="title"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>
        <div class="clientList">
            <Tabs v-model="activeName" style="padding: 0 0 2rem 0" @click="activetab">
                <Tab title="基本信息" name="a">
                    <Form v-model="form" @submit="onSubmit">
                        <van-field
                            v-model="form.vehicleCode"
                            :readonly="
                                form.enumWorkOrderStatus != 1 ||
                                    $route.query.type == '返修派工单'
                            "
                            :required="true"
                            autocomplete="off"
                            :show-error="true"
                            name="车辆编号"
                            label="车辆编号"
                            placeholder="车辆编号"
                            :rules="[ { required: true, message: '必填' } ]"
                            @input="queryvehicleCode" />
                        <van-popup
                            v-model="showpicker"
                            position="bottom"
                            @close="closepopup">
                            <van-picker
                                item-height="1.173rem"
                                show-toolbar
                                :columns="vehicleCodeColumn"
                                @cancel="showpicker = false"
                                @confirm="onConfirm" />
                        </van-popup>
                        <!-- <van-field
                            v-model="form.barCode"
                            disabled
                            :show-error="true"
                            name="条码编号"
                            label="条码编号"
                            placeholder="条码编号" /> -->
                        <van-field
                            v-model="form.barCode"
                            clearable
                            :readonly="form.enumWorkOrderStatus != 1"
                            autocomplete="off"
                            icon="question-o"
                            name="条码编号"
                            label="条码编号"
                            label-class=""
                            :border="true"
                            maxlength="30"
                            placeholder="输入条码编号"
                            :show-error="true"
                            :required="true"
                            :rules="[ { required: true, message: '必填' } ]"
                            bind:click-icon="onClickIcon"
                            @clear="clearbarCode"
                            @keyup="querybarCode" />
                        <van-popup v-model="showbarCode" position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="barCodeColumn"
                                @cancel="showbarCode = false"
                                @confirm="barcodeConfirm" />
                        </van-popup>
                        <van-field
                            v-model="form.category"
                            disabled
                            :show-error="true"
                            name="车辆类别"
                            label="车辆类别"
                            placeholder="车辆类别" />
                        <van-field
                            v-model="form.model"
                            disabled
                            :show-error="true"
                            name="车辆型号"
                            label="车辆型号"
                            placeholder="车辆型号" />
                        <van-field
                            v-model="form.brand"
                            disabled
                            :show-error="true"
                            name="品牌"
                            label="品牌"
                            placeholder="品牌" />
                        <!-- <van-field
                            v-model="form.username"
                            disabled
                            :show-error="true"
                            name="入场日期"
                            label="入场日期"
                            placeholder="入场日期" /> -->
                        <van-field
                            v-model="form.customer"
                            disabled
                            :show-error="true"
                            name="客户名称"
                            label="客户名称"
                            placeholder="客户名称" />

                        <van-field
                            v-model="form.owner"
                            disabled
                            :show-error="true"
                            name="权责人"
                            label="权责人"
                            placeholder="权责人" />
                        <van-field
                            v-model="form.driversnamephone"
                            type="textarea"
                            autosize
                            readonly
                            :show-error="true"
                            name="驾驶员"
                            label="驾驶员"
                            placeholder="驾驶员"
                            @click="queryDrivers" />
                        <van-popup
                            v-model="showdrivers"
                            :style="{ height: '30%' }"
                            position="bottom">
                            <van-checkbox-group v-model="form.checkedDrivers">
                                <van-cell-group>
                                    <van-cell
                                        v-for="(item, index) in driversColumn"
                                        :key="item.id"
                                        clickable
                                        :title="item.driverNamePhone"
                                        @click="toggle(item, index)">
                                        <van-checkbox
                                            slot="right-icon"
                                            ref="checkboxes"
                                            shape="square"
                                            :name="item.driverNamePhone" />
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </van-popup>
                        <van-row
                            v-if="$_has('maintain:workordersearch:edit')"
                            gutter="20"
                            style="margin-top: 1rem; padding: 0 1rem">
                            <van-col v-if="this.$route.query.type === '接单'" span="24">
                                <van-button
                                    round
                                    type="primary"
                                    block
                                    class="nextSpan"
                                    @click="submits">确认接单</van-button>
                            </van-col>
                        </van-row>
                        <div v-if="this.$route.query.type === '处理'" class="nextClass">
                            <Button
                                round
                                block
                                type="info"
                                native-type="submit"
                                class="nextSpan">
                                下一步
                            </Button>
                        </div>
                    </Form>
                </Tab>
                <!-- <Tab title="维修信息" name="b" :disabled="tabdisabled"> -->
                <Tab title="维修信息" name="b">
                    <van-form @submit="onSubmits">
                        <div>
                            <van-panel>
                                <template #header>
                                    <van-cell title="报修信息">
                                        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                                        <template #right-icon>
                                            <!-- <van-icon name="search" style="line-height: inherit;" /> -->
                                            <!-- <van-tag type="danger" @click="routeto">原单据号</van-tag> -->
                                            <span
                                                v-if="
                                                    form.enumWorkOrderType == 2 && title == '返修派工单'
                                                "
                                                class="button-text"
                                                @click="original">原单据号：{{ form.sourceNo }}</span>
                                        </template>
                                    </van-cell>
                                </template>
                                <van-field
                                    v-model="form.enumMaintenanceName"
                                    disabled
                                    :show-error="true"
                                    label="维修方式"
                                    placeholder="维修方式" />
                                <van-field
                                    v-model="form.faultDescription"
                                    rows="1"
                                    autosize
                                    label="故障描述"
                                    disabled
                                    type="textarea"
                                    placeholder="故障描述" />
                                <!-- :disabled="!chuLi" -->
                                <div class="imgAdd" style="padding: 0 0.213333rem">
                                    <span
                                        v-for="(item, index) in form.fileList"
                                        :key="index"
                                        class="itemImg">
                                        <img :src="item.url" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
                                    </span>
                                </div>
                                <!-- <van-checkbox
                                    v-model="form.isNotMaintain"
                                    shape="square"
                                    :disabled="
                                        form.enumWorkOrderStatus != 3 ||
                                            form.enumWorkOrderType == 2 ||
                                            this.$route.query.type === '接单'
                                    "
                                    @click="pickuponly">未维修</van-checkbox> -->
                            </van-panel>
                            <van-panel>
                                <template #header>
                                    <van-cell title="维修项目">
                                        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                                        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                                        <template #right-icon>
                                            <!-- <van-icon name="search" style="line-height: inherit;" /> -->
                                            <van-tag
                                                v-if="
                                                    $_has('maintain:workordersearch:view') &&
                                                        title != '返修派工单'
                                                "
                                                style="margin-left: 10px"
                                                type="danger"
                                                @click="routetos">整车图片</van-tag>
                                            <van-tag
                                                v-if="
                                                    $_has('maintain:workordersearch:view') &&
                                                        title != '返修派工单'
                                                "
                                                style="margin-left: 10px"
                                                type="danger"
                                                @click="routeto">维修历史</van-tag>
                                        </template>
                                    </van-cell>
                                </template>
                                <van-cell
                                    v-for="(item, index) in form.items"
                                    v-if="form.items"
                                    :key="index"
                                    is-link
                                    @click="details(item, index)">
                                    <!-- <van-row class="maintainItemClass">
                                        <van-col span="1">
                                            <p>{{ index+1 }}</p>
                                        </van-col>
                                        <van-col span="20">
                                            <p class="listp">
                                                <span class="info-span-bottom">{{ item.maintainItem }}</span>
                                                <span class="info-span-bottom" style="font-size:16px">{{ item.workHour }}</span>

                                            </p>
                                            <p class="listp margin-top5">
                                                <span class="info-span-bottom">{{ `${item.position?item.position:''}-${item.part?item.part:''}` }}</span>
                                            </p>
                                            <p class="listp margin-top5">
                                                <span class="info-span-bottom" style="width:25%">{{ item.teamName }}</span>
                                                <span class="info-span-bottom" style="width:40%">{{ item.workerNames }}</span>
                                                <span class="info-span-bottom" style="width:20%">{{ item.totalPrice }}</span>
                                            </p>
                                        </van-col>
                                        <van-col style="width:10px" span="3"><span type="primary" round>{{ convertStatus(item.enumFaultReason) }}</span></van-col>
                                    </van-row> -->
                                    <van-row>
                                        <div style="display: flex; justify-content: space-between">
                                            <div style="display: flex">
                                                <p
                                                    style="
                            border-radius: 5px;
                            margin-left: 20px;
                            font-size: 10px;
                            margin-top: 3px;
                            width: 26px;
                            height: 26px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background: #00cc99;
                          ">
                                                    {{ index + 1 }}
                                                </p>
                                                <span
                                                    style="
                            font-size: 12px;
                            position: absolute;
                            left: 13vw;
                            font-weight: 700;
                          ">维修类型：{{ item.maintenTypeName }}</span>
                                            </div>
                                            <p
                                                style="
                          color: #1890ff;
                          margin-right: 4vw;
                          font-size: 26px;
                          margin-top: -3px;
                        ">
                                                {{ item.maintainItemNum }}
                                            </p>
                                        </div>

                                        <div styel=" margin-left:20px;">
                                            <span
                                                style="
                          font-size: 12px;
                          margin-left: 13vw;
                          font-weight: 700;
                        ">维修项目：{{ item.maintainItem }}</span>
                                        </div>
                                        <!-- <p>
                                            <span style="font-size:16px">{{ item.workHour }}</span>
                                            <span  style="font-size:16px">{{ item.unitPrice }}</span>
                                        </p> -->
                                        <p style="height: 2vh">
                                            <span
                                                style="font-size: 12px; width: 25%; margin-left: 13vw">维修队：{{ item.teamName }}</span>
                                        </p>
                                        <p style="border-bottom: 1px solid #ccc; height: 5vh">
                                            <span
                                                style="font-size: 12px; width: 25%; margin-left: 13vw">工位：{{ item.stationName }}</span>
                                            <span
                                                style="font-size: 12px; width: 20%; margin-left: 10vw">{{ item.totalPrice }}元</span>
                                        </p>
                                        <p>
                                            <span style="width: 40%">{{ item.workerNames }}</span>
                                        </p>
                                    </van-row>
                                    <van-row>
                                        <div style="padding-left: 0vw; margin-top: 2vw">
                                            <div v-if="item.faultPhoto">
                                                <img
                                                    v-for="(x, index) in item.faultPhoto.split(';')"
                                                    :key="index"
                                                    
                                                    style="width: 100px; height: 100px; margin-right: 5vw"
                                                    :src="x"
                                                    alt=""
                                                    @click.stop="clickImg($event)">
                                                </div>
                                            <div v-if="item.oldNewPhoto">
                                            <img
                                                v-for="(x, index) in item.oldNewPhoto.split(';')"
                                                    :key="index"
                                                style="width: 100px; height: 100px; margin-right: 5vw"
                                                :src="x"
                                                alt=""
                                                @click.stop="clickImg($event)">
                                            </div>
                                            <div v-if="item.faultOver">
                                            <img
                                                v-for="(x, index) in item.faultOver.split(';')"
                                                    :key="index"
                                                style="width: 100px; height: 100px; margin-right: 5vw"
                                                :src="x"
                                                alt=""
                                                @click.stop="clickImg($event)">
                                            </div>
                                        </div>
                                    </van-row>
                                    <van-cell v-if="form.items.length > 0" title="配件明细" />
                                    <el-table
                                        v-if="form.items.length > 0"
                                        :data="item.parts"
                                        border
                                        style="width: 100%"
                                        :header-cell-class-name="'tq-table-rom-header'"
                                        size="mini">
                                        <el-table-column
                                            label="序号"
                                            type="index"
                                            width="49"
                                            align="center" />
                                        <el-table-column
                                            v-if="$route.query.type == '返修结算单'"
                                            prop="isRework"
                                            show-overflow-tooltip
                                            label="是否返修">
                                            <template slot-scope="scope">
                                                <el-switch
                                                    v-model="scope.row.isRework"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    @change="handleStatusChange(scope.row.isRework)" />
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="billStatusName"
                                            label="状态"
                                            width="50">
                                            <template slot-scope="scope">
                                                {{
                                                    scope.row.billStatusName
                                                        ? scope.row.billStatusName
                                                        : '正常'
                                                }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="customerBillNo" label="出库单号">
                                            <template slot-scope="scope">
                                                {{
                                                    scope.row.billStatusName == '缺件'
                                                        ? '-'
                                                        : scope.row.customerBillNo
                                                }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="part" label="配件名称" />
                                        <el-table-column prop="num" label="数量" width="50" />
                                        <el-table-column prop="unitPrice" label="单价">
                                            <template slot-scope="scope">
                                                {{
                                                    scope.row.billStatusName == '缺件'
                                                        ? '-'
                                                        : scope.row.unitPrice
                                                }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="totalPrice" label="合计金额">
                                            <template slot-scope="scope">
                                                {{
                                                    scope.row.billStatusName == '缺件'
                                                        ? '-'
                                                        : scope.row.totalPrice
                                                }}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </van-cell>
                            </van-panel>
                            <van-cell
                                v-if="
                                    $route.query.type != '返修派工单' &&
                                        title != '返修派工单' &&
                                        form.enumWorkOrderStatus != 6 &&
                                        !form.isOnlyRequisitionPart &&
                                        !form.isNotMaintain &&
                                        this.$route.query.type === '处理'
                                "
                                border
                                title="添加维修项目"
                                is-link
                                @click="showLists" />
                        </div>
                        <div>
                            <van-popup
                                v-model="showList"
                                position="bottom"
                                :style="{ height: '80%' }"
                                @click-overlay="closeshowList">
                                <!-- <van-field
                    v-model="maintainItemdetails.position"
                    readonly
                    autocomplete="off"
                    :show-error="true"
                    name="部位"
                    label="部位"
                    placeholder="部位"
                    @click="title == '返修派工单'|| positionOrPart||form.isNotMaintain||form.isOnlyRequisitionPart? showpositions = false : showpositions = true" />
                <van-popup
                    v-model="showpositions"
                    position="bottom">
                    <van-picker
                        item-height="1.173rem"
                        show-toolbar
                        :columns="positions"
                        @cancel="showpositions = false"
                        @confirm="confirmposition" />
                </van-popup>
                <van-field
                    v-model="maintainItemdetails.part"
                    readonly
                    autocomplete="off"
                    :show-error="true"
                    name="部件"
                    label="部件"
                    placeholder="部件"
                    @click="bwpart" />
                <van-popup
                    v-model="showpart"
                    position="bottom">
                    <van-picker
                        item-height="1.173rem"
                        show-toolbar
                        :columns="parts"
                        @cancel="showpart = false"
                        @confirm="confirmpart" />
                </van-popup> -->
                                <van-field
                                    v-model="maintainItemdetails.maintenTypeName"
                                    readonly
                                    autocomplete="off"
                                    :show-error="true"
                                    name="maintenTypeName"
                                    label="维修类型"
                                    placeholder="选择维修类型" />
                                <!-- <van-popup
                                    v-model="showmaintainItemse"
                                    :style="{ height: '35%' }"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="maintenTypes"
                                        @cancel="showmaintainItems = false"
                                        @confirm="maintenTypeNamese" />
                                </van-popup> -->
                                <!-- <van-field
                                    v-if="maintainItemName == '详情'"
                                    v-model="maintainItemdetails.maintainItem"
                                    autocomplete="off"
                                    :required="true"
                                    :show-error="true"
                                    name="maintainItem"
                                    label="维修项目"
                                    placeholder="选择项目"
                                    :rules="[ { required: true, message: '必填' } ]"
                                    @input="queryMaintainItem"
                                    @blur="blurMaintainItem(maintainItemdetails.maintainItem)" /> -->
                                <van-field
                                    v-model="maintainItemdetails.maintainItem"
                                    autocomplete="off"
                                    :show-error="true"
                                    name="maintainItem"
                                    label="维修项目"
                                    placeholder="选择项目"
                                    @click="showmaintainItems = true"
                                    @input="queryMaintainItem"
                                    @blur="blurMaintainItem(maintainItemdetails.maintainItem)" />
                                <van-popup
                                    v-model="showmaintainItems"
                                    :style="{ height: '35%' }"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        title="请输入维修项目"
                                        :columns="maintainItemslist"
                                        @cancel="showmaintainItems = false"
                                        @confirm="confirmmaintainItem" />
                                </van-popup>
                                <van-field
                                    v-model="maintainItemdetails.maintainType"
                                    autocomplete="off"
                                    readonly
                                    name="maintainType"
                                    label="项目分类"
                                    placeholder="自动带出" />
                                <!-- <van-field
                                    v-model="maintainItemdetails.maintainItemNum"
                                    autocomplete="off"
                                    :show-error="true"
                                    name="maintainItemNum"
                                    label="数量"
                                    placeholder="数量"
                                    @input="maintainItemdetails.maintainItemNum= checkNumberFloat(maintainItemdetails.maintainItemNum)" /> -->
                                <van-row>
                                    <van-col class="num">数量</van-col>
                                    <van-col><van-stepper
                                        v-model="maintainItemdetails.maintainItemNum"
                                        class="num-stepper"
                                        min="1"
                                        max="99"
                                        integer /></van-col>
                                </van-row>
                                <van-field
                                    v-model="maintainItemdetails.workHour"
                                    autocomplete="off"
                                    :required="true"
                                    readonly
                                    :show-error="true"
                                    name="workHour"
                                    label="工时"
                                    placeholder="工时"
                                    :rules="[ { required: true, message: '必填' } ]" />
                                <!--  @input="maintainItemdetails.workHour= checkNumberFloat(maintainItemdetails.workHour)" -->
                                <van-field
                                    v-model="maintainItemdetails.unitPrice"
                                    autocomplete="off"
                                    readonly
                                    :required="true"
                                    :show-error="true"
                                    name="unitPrice"
                                    label="工时单价"
                                    placeholder="工时单价"
                                    :rules="[ { required: true, message: '必填' } ]" />
                                <!--  @input="maintainItemdetails.unitPrice= checkNumberFloat(maintainItemdetails.unitPrice)"  -->
                                <van-field
                                    v-model="maintainItemdetails.teamName"
                                    required
                                    readonly
                                    autocomplete="off"
                                    :show-error="true"
                                    name="维修队"
                                    label="维修队"
                                    :rules="[ { required: true, message: '必填' } ]"
                                    placeholder="维修队"
                                    @click="teamlist" />
                                <!-- @click="teamlist" -->
                                <van-popup
                                    v-model="showteam"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="teamNames"
                                        @cancel="showteam = false"
                                        @confirm="confirmteam" />
                                </van-popup>
                                <!-- <van-field
                            v-model="form.username"
                            disabled
                            :show-error="true"
                            name="入场日期"
                            label="入场日期"
                            placeholder="入场日期" /> -->
                                <div
                                    v-for="(item, index) of maintainItemdetails.workOrderMen"
                                    :key="index">
                                    <van-row>
                                        <!-- <van-col :span="11">
                                            <van-field
                                                v-model="item.workerName"
                                                :required="true"
                                                readonly
                                                autocomplete="off"
                                                label="维修工"
                                                :border="true"
                                                :rules="[ { required: true, message: '必填' } ]"
                                                placeholder="请输入" @click="getWorkers(index)" />
                                            <van-popup
                                                v-model="showwork"
                                                :style="{ height: '30%' }"
                                                position="bottom">
                                                <van-picker
                                                    item-height="1.173rem"
                                                    show-toolbar
                                                    :columns="workers"
                                                    @cancel="showwork = false"
                                                    @confirm="confirmwork" />
                                            </van-popup>
                                        </van-col> -->
                                        <!-- <van-col :span="11">
                                            <van-field
                                                v-model="item.percent"
                                                :required="true"
                                                :rules="[ { required: true, message: '必填' } ]"
                                                label="占比"
                                                :border="true"
                                                placeholder="请输入" />
                                        </van-col> -->
                                        <van-col :span="24">
                                            <van-field
                                                v-model="maintainItemdetails.stationName"
                                                label="工位"
                                                autocomplete="off"
                                                :show-error="true"
                                                name="stationName"
                                                :border="true"
                                                placeholder="请输入"
                                                required
                                                readonly
                                                @click="worklist" />
                                            <van-popup
                                                v-model="showworkse"
                                                :style="{ height: '30%' }"
                                                position="bottom">
                                                <van-picker
                                                    item-height="1.173rem"
                                                    show-toolbar
                                                    :columns="workerNamese"
                                                    @cancel="showworkse = false"
                                                    @confirm="worker" />
                                            </van-popup>

                                            <!-- <van-popup
                                                v-model="showmaintainItemse"
                                                :style="{ height: '35%' }"
                                                position="bottom">
                                                <van-picker
                                                    item-height="1.173rem"
                                                    show-toolbar
                                                    :columns="maintenTypes"
                                                    @cancel="showmaintainItems = false"
                                                    @confirm="maintenTypeNamese" />
                                            </van-popup> -->
                                        </van-col>
                                        <van-col :span="24">
                                            <van-field
                                                v-model="maintainItemdetails.remark"
                                                label="备注"
                                                name="remark"
                                                :border="true"
                                                placeholder="请输入" />
                                        </van-col>
                                        <!-- <van-col :span="1" class="icon-style">
                                            <van-icon name="plus" @click="addWorkOrder" />
                                        </van-col> -->
                                        <van-col :span="1" @click="deltWorkOrder(index)">
                                            <span style="font-size: 20px; margin-top: 5px">{{
                                                item.deltBtn
                                            }}</span>
                                        </van-col>
                                    </van-row>
                                </div>
                                <van-field
                                    v-model="maintainItemdetails.totalPrice"
                                    disabled
                                    :show-error="true"
                                    name="合计金额"
                                    label="合计金额"
                                    placeholder="合计金额"
                                    class="moneyColor" />
                                <div class="nextClass">
                                    <div class="container">
                                        <div class="Uploader">
                                            <div class="image">故障点照片</div>
                                            <div class="imgAdd">
                                                <span
                                                    v-for="(item, index) in faultPhotoList"
                                                    :key="index"
                                                    class="itemImg">
                                                    <img :src="item.url" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
                                                    <img
                                                        v-if="$route.query.type == '处理'"
                                                        src="./image/del.png"
                                                        alt=""
                                                        class="delte"
                                                        @click="delImg('faultPhoto', 'faultPhotoList',index)">
                                                </span>
                                                <div
                                                    v-show="
                                                        $route.query.type == '处理' &&
                                                            faultPhotoList.length < 3
                                                    "
                                                    class="fileupload-box">
                                                    <div
                                                        class="c"
                                                        @click="
                                                            photographs('faultPhoto','faultPhotoList')
                                                        ">
                                                        <img id="image" src="./image/1.png">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <van-popup
                                        v-model="showworkses"
                                        :style="{ height: '30%' }"
                                        position="bottom">
                                        <van-picker
                                            item-height="1.173rem"
                                            show-toolbar
                                            :columns="[ {value:0,text:'拍照',faultPhoto:'faultPhoto',faultPhotoList:'faultPhotoList'},
                                                        {value:1,text:'相册',faultPhoto:'faultPhoto',faultPhotoList:'faultPhotoList'} ]"
                                            @cancel="showworkses = false"
                                            @confirm="photograph" />
                                    </van-popup>
                                    <div class="container">
                                        <div class="Uploader">
                                            <div class="image">新旧件对比</div>
                                            <div class="imgAdd">
                                                <span
                                                    v-for="(item, index) in oldNewPhotoList"
                                                    :key="index"
                                                    class="itemImg">
                                                    <img :src="item.url" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
                                                    <img
                                                        v-if="$route.query.type == '处理'"
                                                        src="./image/del.png"
                                                        alt=""
                                                        class="delte"
                                                        @click="delImg('oldNewPhoto', 'oldNewPhotoList',index)">
                                                </span>
                                                <div
                                                    v-show="
                                                        $route.query.type == '处理' &&
                                                            oldNewPhotoList.length < 3
                                                    "
                                                    class="fileupload-box">
                                                    <div
                                                        class="c"
                                                        @click="
                                                            photographs('oldNewPhoto','oldNewPhotoList')
                                                        ">
                                                        <img id="image" src="./image/1.png">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <van-popup
                                        v-model="oldandnew"
                                        :style="{ height: '30%' }"
                                        position="bottom">
                                        <van-picker
                                            item-height="1.173rem"
                                            show-toolbar
                                            :columns="[ {value:0,text:'拍照',faultPhoto:'oldNewPhoto',faultPhotoList:'oldNewPhotoList'},
                                                        {value:1,text:'相册',faultPhoto:'oldNewPhoto',faultPhotoList:'oldNewPhotoList'} ]"
                                            @cancel="oldandnew = false"
                                            @confirm="photograph" />
                                    </van-popup>
                                    <div class="container">
                                        <div class="Uploader">
                                            <div class="image">故障完成</div>
                                            <div class="imgAdd">
                                                <span
                                                    v-for="(item, index) in faultOverList"
                                                    :key="index"
                                                    class="itemImg">
                                                    <img :src="item.url" alt="图片" class="uploadimg" @click.stop="clickImg($event)">
                                                    <img
                                                        v-if="$route.query.type == '处理'"
                                                        src="./image/del.png"
                                                        alt=""
                                                        class="delte"
                                                        @click="delImg('faultOver', 'faultOverList',index)">
                                                </span>
                                                <div
                                                    v-show="
                                                        $route.query.type == '处理' &&
                                                            faultOverList.length < 3
                                                    "
                                                    class="fileupload-box">
                                                    <div
                                                        class="c"
                                                        @click="
                                                            photographs('faultOver','faultOverList')
                                                        ">
                                                        <img id="image" src="./image/1.png">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <van-popup
                                        v-model="faultcompletion"
                                        :style="{ height: '30%' }"
                                        position="bottom">
                                        <van-picker
                                            item-height="1.173rem"
                                            show-toolbar
                                            :columns="[ {value:0,text:'拍照',faultPhoto:'faultOver',faultPhotoList:'faultOverList'},
                                                        {value:1,text:'相册',faultPhoto:'faultOver',faultPhotoList:'faultOverList'} ]"
                                            @cancel="faultcompletion = false"
                                            @confirm="photograph" />
                                    </van-popup>
                                    <!-- <van-field
                                    v-model="maintainItemdetails.enumFaultReasonname"
                                    readonly
                                    :required="true"
                                    :show-error="true"
                                    name="故障原因"
                                    label="故障原因"
                                    placeholder="故障原因"
                                    :rules="[ { required: true, message: '必填' } ]"
                                    @click="showenumFaultReasons" />
                                <van-popup
                                    v-model="showenumFaultReason"
                                    position="bottom">
                                    <van-picker
                                        item-height="1.173rem"
                                        show-toolbar
                                        :columns="enumFaultReasons"
                                        @cancel="showenumFaultReason = false"
                                        @confirm="confirmenumFaultReason" />
                                </van-popup> -->
                                    <div class="nextClass">
                                        <Button
                                            round
                                            block
                                            type="info"
                                            native-type="submit"
                                            class="nextSpan">
                                            保存
                                        </Button>
                                    </div>
                                </div></van-popup>
                        </div>
                    </van-form>
                    <van-row
                        v-if="$_has('maintain:workordersearch:edit') && this.$route.query.type === '处理'"
                        gutter="20"
                        style="margin-top: 1rem; padding: 0 1rem">
                        <van-col v-if="this.$route.query.type === '处理'&&this.$route.query.status!=6" span="12">
                            <van-button
                                round
                                type="primary"
                                block
                                class="nextSpan"
                                @click="submit(1)">提交</van-button>
                        </van-col>
                        <van-col v-if="
                            $_has('maintain:workordersearch:edit') &&
                            form.enumWorkOrderStatus != 6 &&
                            form.enumWorkOrderStatus != 7 &&
                            !form.isOnlyRequisitionPart &&
                            form.repairCompleteTime == null
                        " span="12">
                            <van-button class="nextSpan" round type="primary" block @click="submit(2)">提交质检</van-button>
                        </van-col>
                    </van-row>



                    <van-row
                        v-if="$_has('maintain:workordersearch:edit')"
                        gutter="20"
                        style="margin-top: 1rem; padding: 0 1rem">
                        <van-col v-if="this.$route.query.type === '接单'" span="24">
                            <van-button
                                round
                                type="primary"
                                block
                                class="nextSpan"
                                @click="submits">确认接单</van-button>
                        </van-col>
                    </van-row>
                </Tab>
            </Tabs>
        </div>
        <Repairpopup
            v-if="equiTimingRunVisible"
            ref="dalong"
            :visible.sync="equiTimingRunVisible"
            :modal-obj="modalObj"
            @getDetails="getDetails" />
        <el-dialog
            :close-on-click-modal="false"
            title="保养提醒/缺件到货提醒"
            :visible.sync="centerDialogVisible"
            width="80%">
            <p v-if="maintainStatus == 1">{{ maintainMessage }}</p>
            <br>
            <p v-if="maintenanceStatus == 1">上次维修缺件已到货是否进行继续维修</p>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="displaycancles">取消并不再提醒</el-button>
                <el-button size="mini" @click="centerDialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="displaymplists">确 定</el-button>
            </span>
        </el-dialog>
        <bottom />
    </div>
</template>

<script>
var moment = require('moment')
import { Button, Tab, Tabs, NavBar, Form, Toast, Dialog } from 'vant'
import bottom from '@/components/bottom'
import {
    displayreminder,
    displayteam,
    GetworkerByMtId,
    WorkOrdertempSave,
    workOrderDispatch,
    teamOrgNodeId,
    WorkOrderhistoryList,
    WorkOrdercommitQC,
    qualityCheckSubmit,
    qualityCheckSubmits,
    displaymplist,
    displaycancle
} from '@/api/maintain'
import {
    getvehicleCodeList,
    getCarDetails,
    getDriverList,
    getMaintenitemlistForDropdw,
    getDictionarySelect,
    getVehiclepositList,
    getOdd,
    getbarCodeList,
    getvehicleInfoItem,
    stationList

} from '@/api/basics'
import {
    StationWorkList
} from '@/api/maintain'
import { mapGetters } from 'vuex'
import Repairpopup from './components/repairpopup.vue'
import BigImg from './components/bigImg.vue'

export default {
    name: 'Workorderlistsearchdetail',
    components: {
        bottom,
        [Button.name]: Button,
        NavBar,
        Tab,
        Tabs,
        Form,
        Button,
        Repairpopup,
        Dialog,
        BigImg
    },
    data() {
        return {
            showImg: false,
            imgSrc: '',
            show: false,
            modalObj: {
                title: '维修历史',
                tableData: [],
                item: null
            },
            maintenTypeIdse: '',
            faultPhotoList: [],
            oldNewPhotoList: [],
            faultOverList: [],
            fileList: [],
            centerDialogVisible: false,
            // unitpricereadonly: true,
            equiTimingRunVisible: false,
            showenumFaultReason: false,
            showwork: false,
            isTeams: false,
            showteam: false,
            showpart: false,
            workerNamese: [],
            maintenTypes: [],
            showpositions: false,
            showmaintainItems: false,
            chosenContactId: null,
            editingContact: {},
            showList: false,
            showEdit: false,
            isEdit: false,
            projectreadonly: false,
            form: {
                driverSign: null,
                dispatcherSign: null,
                oldnum: null,
                sheetNo: null,
                id: uuid(),
                enumWorkOrderType: 1,
                enumWorkOrderStatus: 1, // 单据状态
                vehicleCode: null, // 车辆编号
                barCode: null, // 条码编号
                category: null, // 车辆类别
                brand: null, // 品牌
                model: null, // 型号
                customer: null, // 客户名称
                phone: null, // 电话
                owner: null, // 权责人
                driver: null, // 驾驶员
                drivers: [], // 驾驶员电话+号码
                driverPhone: null, // 驾驶员电话
                entryTime: null, // 入场时间
                enumMaintenanceType: 1, // 维修类型
                faultDescription: null, // 故障描述
                items: [], // 维修项目
                checkedDrivers: [],
                enumMaintenanceName: '现场维修'
            },
            maintainItemdetails: {
                workOrderMen: [{ workerId: null, workerName: null, percent: null }],
                maintainItemNum: '',
                workHour: '',
                unitPrice: null,
                id: uuid(),
                partId: null,
                part: null,
                position: null,
                maintainItemId: null
            },
            items: [],
            oldandnew: false,
            faultcompletion: false,
            maintainStatus: null,
            maintenanceStatus: null,
            tabdisabled: true,
            title: '派工单',
            jbinfo: null,
            teamNames: [],
            showworkses: false,
            parts: [],
            positions: [],
            maintainItemslist: [],
            num: null,
            driversColumn: [],
            showdrivers: false,
            showpicker: false,
            activeName: 'a',
            finishedText: '已加载全部',
            refreshing: false,
            loading: false,
            finished: false,
            showmaintainItemse: false,
            workers: [],
            vehicleCodeColumn: [],
            showworkse: false,
            value1: 0,
            value2: '',
            enumFaultReasons: [
                { text: '自然损坏', value: 1 },
                { text: '驾驶操作', value: 2 },
                { text: '配件质量', value: 3 },
                { text: '维修装配', value: 4 }
            ],
            option2: [],
            maintainItemName: '详情',
            positionOrPart: true,
            showbarCode: false, // 条码编号下拉框
            barCodeColumn: [], // 条码编号下拉框数据
            chuLi: false, // 判断处理还是接单false未接单true
            fileList: []
        }
    },

    computed: {
        ...mapGetters(['companyId'])
    },

    maintainStatus(val) {
        if (val == 1) {
            this.centerDialogVisible = true
        }
    },
    computed: {
        ...mapGetters(['companyId'])
    },
    watch: {
        $route: {
            handler: function(val, oldVal) {
                console.log(val, 'asdhjash')
                if (val.path == '/fxdispatchdetails') {
                    this.getDetails()
                }
            },
            // 深度观察监听
            deep: true
        },
        maintainStatus(val) {
            if (val == 1) {
                this.centerDialogVisible = true
            }
        },
        maintenanceStatus(val) {
            if (val == 1) {
                this.centerDialogVisible = true
            }
        },
        activeName(val) {
            console.log(val, this.$route.query.type)
            if (!this.$route.query.type || val == 'a') {
                this.tabdisabled = true
            }
        },
        'maintainItemdetails.maintainItemNum'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = (
                    Number(this.maintainItemdetails.workHour) *
    Number(this.maintainItemdetails.unitPrice)
                ).toFixed(2)
            } else {
                this.maintainItemdetails.totalPrice = (
                    Number(val) *
    this.maintainItemdetails.workHour *
    this.maintainItemdetails.unitPrice
                ).toFixed(2)
            }
        },
        'maintainItemdetails.workHour'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = 0
            } else if (
                !this.maintainItemdetails.maintainItemNum ||
  this.maintainItemdetails.maintainItemNum == 0
            ) {
                this.maintainItemdetails.totalPrice = (
                    Number(val) * this.maintainItemdetails.unitPrice
                ).toFixed(2)
            } else {
                console.log(this.maintainItemdetails.maintainItemNum)
                this.maintainItemdetails.totalPrice = (
                    this.maintainItemdetails.maintainItemNum *
    Number(val) *
    this.maintainItemdetails.unitPrice
                ).toFixed(2)
            }
        },
        'maintainItemdetails.unitPrice'(val) {
            if (!val || val == 0) {
                this.maintainItemdetails.totalPrice = 0
            } else if (
                !this.maintainItemdetails.maintainItemNum ||
  this.maintainItemdetails.maintainItemNum == 0
            ) {
                this.maintainItemdetails.totalPrice = (
                    Number(val) * this.maintainItemdetails.workHour
                ).toFixed(2)
            } else {
                console.log(this.maintainItemdetails.maintainItemNum)
                this.maintainItemdetails.totalPrice = (
                    this.maintainItemdetails.maintainItemNum *
    Number(val) *
    this.maintainItemdetails.workHour
                ).toFixed(2)
            }
        }
    },
    mounted() {
        if (this.$route.query.type == '接单') {
        }
        window['clicktotakephotos'] = (data) => {
            this.clicktotakephotos(data)
        }
        window['clicktotakephotoses'] = (data) => {
            this.clicktotakephotoses(data)
        }
        if (this.$route.query.type != '处理') {
            this.getOdd()
        }
        if (this.$route.query.type === '接单') {
            this.chuLi = false
        } else {
            this.chuLi = true
        }
        if (this.$route.query.activeName == 'b') {
            this.activeName = 'b'
        } else {
            this.activeName = 'a'
        }
        this.getDetails()
    },
    async created() {
        // 维修部位
        getDictionarySelect({ Code: 'Maintain:PositionsType' }).then((res) => {
            if (res.code === 200) {
                this.positions = res.data
                res.data.forEach((item) => {
                    item.text = item.name
                })
                this.positions = res.data
            }
        })
        // 获取维修类型
        getDictionarySelect({ Code: 'Maintain:MaintenceType' }).then((res) => {
            if (res.isSuccess) {
                console.log(res.data)
                this.maintenTypes = res.data
                this.maintenTypes.forEach((item) => {
                    item.text = item.name
                })
            }
        })
        const res = await getMaintenitemlistForDropdw({
            keywords: '',
            ModelIdStr: this.form.modelId,
            beginDate: '',
            endDate: '',
            maintenTypeIds: this.maintainItemdetails.maintenTypeId
                ? [this.maintainItemdetails.maintenTypeId]
                : [],
            PageSize: 20,
            PageIndex: 1
        })
        res.data.pagerData.forEach((item) => {
            item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
        })
        this.maintainItemslist = res.data.pagerData
        // this.setParameters()
        this.getDetails()
    },
    activated() {
        this.showImg = false
        // this.setParameters()
        window['clicktotakephotos'] = (data) => {
            this.clicktotakephotos(data)
        }
        window['clicktotakephotoses'] = (data) => {
            this.clicktotakephotoses(data)
        }
        this.getDetails()
    },
    methods: {
        clickImg(e) {
            this.showImg = true
            // 获取当前图片地址
            this.imgSrc = e.currentTarget.src
        },
        viewImg() {
            this.showImg = false
        },
        visitSelectDate(date) {
            var month =
        date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1)
            : date.getMonth() + 1
            var currentDate =
        date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            this.ConfirmTime =
        date.getFullYear() +
        '-' +
        month +
        '-' +
        currentDate +
        ' ' +
        hours +
        ':' +
        minutes
            this.date = false
        },
        // 工位确认
        worker(val, index) {
            console.log(val, index)
            // this.form.items.stationName=item.stationName
            this.workerNamese.forEach((res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.stationName = res.texts
                    this.maintainItemdetails.stationId = res.id
                    this.maintainItemdetails.stationCode = res.stationCode
                    this.showworkse = false
                }
            })
        },
        // 工位档案列表
        worklist(val) {
            console.log(val, 'maintainItemdetailsmaintainItemdetails')
            StationWorkList({
                StationCode: '',
                StationName: null,
                Status: null,
                CreatorName: '',
                StartDate: '',
                EndDate: '',
                status: 1,
                maintainId: this.maintainItemdetails.teamId,
                MaintainTypeId: this.maintenTypeIdse,
                PageIndex: 1,
                PageSize: 10000
            }).then((res) => {
                this.workerNamese = res.data.pagerData
                this.workerNamese.forEach((item) => {
                    item.text = item.workNum
                    item.texts = item.stationName
                    //
                })
                this.showworkse = true
            })
        },
        // 确认维修类型
        async maintenTypeNamese(val) {
            this.maintenTypeIdse = val.id
            this.maintenTypes.forEach(async(res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.maintenTypeName = res.name
                    this.maintainItemdetails.maintenTypeId = res.code
                    this.showmaintainItemse = false
                    this.maintainItemdetails.factor = res.factor
                    this.maintainItemdetails.code = res.code
                }
            })
            const res = await getMaintenitemlistForDropdw({
                keywords: '',
                ModelIdStr: this.form.modelId,
                beginDate: '',
                endDate: '',
                maintenTypeIds: this.maintainItemdetails.maintenTypeId
                    ? [this.maintainItemdetails.maintenTypeId]
                    : [],
                PageSize: 20,
                PageIndex: 1
            })
            res.data.pagerData.forEach((item) => {
                item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
            })
            this.maintainItemslist = res.data.pagerData
        },
        // 拍照相册确认
        photograph(val) {
            if (val.value == 0) {
                this.photo = val.faultPhoto
                this.photoList = val.faultPhotoList
                const data = this.moment().format('YYYY-MM-DD HH:mm:ss')
                let gw = ''
                if (this.form.items.length > 0) {
                    gw = this.form.items[0].stationName
                }
                const code = this.form.vehicleCode
                const str = gw ? `${data},,${gw},,${code}` : `${data},,${code}`
                window.test.openCamera(str)
                if (val.faultPhoto == 'faultPhoto') {
                    this.showworkses = false
                } else if (val.faultPhoto == 'oldNewPhoto') {
                    this.oldandnew = false
                } else if (val.faultPhoto == 'faultOver') {
                    this.faultcompletion = false
                }
            } else {
                this.photo = val.faultPhoto
                this.photoList = val.faultPhotoList
                const data = this.moment().format('YYYY-MM-DD HH:mm:ss')
                let gw = ''
                if (this.form.items.length > 0) {
                    gw = this.form.items[0].stationName
                }
                const code = this.form.vehicleCode
                const str = gw ? `${data},,${gw},,${code}` : `${data},,${code}`
                window.test.openAlbum(str)
                if (val.faultPhoto == 'faultPhoto') {
                    this.showworkses = false
                } else if (val.faultPhoto == 'oldNewPhoto') {
                    this.oldandnew = false
                } else if (val.faultPhoto == 'faultOver') {
                    this.faultcompletion = false
                }
            }
        },
        pickuponly(val) {
            if (
                this.form.enumWorkOrderType == 2 ||
            this.form.enumWorkOrderStatus != 3 ||
            this.$route.query.type == '接单'
            ) {
                return
            }
            Dialog.setDefaultOptions({
                width: '6rem'
            })
            Dialog.confirm({
                message: '勾选后，本次派工单将清空所有维修项目更改为未维修'
            })
                .then(async() => {
                    this.form.items = []
                    this.form.items.push({
                        id: uuid(),
                        workOrderId: this.form.id,
                        maintainItemId: null,
                        maintainItem: '未维修',
                        partId: null,
                        part: null,
                        position: null,
                        workHour: 0,
                        unitPrice: 0,
                        maintainItemNum: 0,
                        teamId: this.items[0].teamId,
                        teamName: this.items[0].teamName,
                        teamOrgNodeId: this.items[0].teamOrgNodeId,
                        totalPrice: null,
                        enumFaultReason: 1,
                        disabled: false,
                        billDetailList: [],
                        enumQualityInspectionResult: 1,
                        parts: [],
                        workOrderMen: [{ workerId: null, workerName: null, percent: null }]
                    })
                    this.form.isNotMaintain = true
                })
                .catch(() => {
                    this.form.isNotMaintain = false
                    this.form.items = this.items
                })
        },
        original() {
            this.$router.push({
                path: '/dispatchList',
                query: { id: this.form.sourceId, type: '处理' }
            })
            // this.$route.query.type = '处理'
            // this.$route.query.id = this.form.sourceId
            this.getDetails()
        },
        // 路由跳转初始化
        async getDetails() {
            // if(){

            // }
            this.showList = false
            if (this.$route.query.type == '处理' && !this.$route.query.allCar) {
                this.cardisabled = true
                if (this.$route.query.activeName == 'b') {
                    this.activeName = 'b'
                } else {
                    this.activeName = 'a'
                }
                // this.activeName = 'a'
                console.log(this.$store.state.user, 'this.$store.state.user.userInfo')
                const OrgIds = this.jwtDecode(this.$store.state.user.partToken)
                const OrgId = OrgIds.OrgId
                const res = await teamOrgNodeId(
                    this.$route.query.id,
                    OrgId
                )
                if (res.data.entranceUrl) {
                    res.data.fileList = []
                    // const picture = res.data.entranceUrl.split(';')
                    var picture = res.data.entranceUrl.split(';').filter(function(s) {
                        return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
                    })
                    console.log(picture)
                    picture.forEach((item) => {
                        res.data.fileList.push({
                            url: item
                        })
                    })
                }
                this.resData = JSON.parse(JSON.stringify(res.data.items))
                if (res.data.items.length > 0) {
                    res.data.items.forEach((data) => {
                        data.status = true
                        data.teamNames = ''
                        if (data.workOrderMen.length > 0) {
                            data.workOrderMen.forEach((item) => {
                                data.workerNames = data.workOrderMen
                                    .map(function(obj) {
                                        return obj.workerName
                                    })
                                    .join(',')
                            })
                        }
                    })
                }
                this.form.vehicleCode = res.data.vehicleCode
                this.form.customerId = res.data.customerId
                await this.getHandList()
                console.log(this.driversColumn, res.data.drivers, '2323')

                if (this.driversColumn && this.driversColumn.length > 0) {
                    this.driversColumn.forEach((element) => {
                        res.data.drivers.forEach((items) => {
                            if (element.driverNamePhone == items) {
                                element.checked = true
                            }
                        })
                    })
                } else {
                    res.data.drivers.forEach((items) => {
                        const myObject = {
                            driverNamePhone: null,
                            checked: false
                        }
                        myObject.driverNamePhone = items
                        myObject.checked = true
                        this.driversColumn.push(myObject)
                    })
                }
                const arr = this.driversColumn.filter(function(obj) {
                    return obj.checked
                })
                res.data.driversnamephone = arr
                    .map(function(obj) {
                        return obj.driverNamePhone
                    })
                    .join(',')
                res.data.checkedDrivers = res.data.driversnamephone.split(',')
                res.data.enumMaintenanceType == 1
                    ? (res.data.enumMaintenanceName = '现场维修')
                    : (res.data.enumMaintenanceName = '场内维修')
                res.data.enumWorkOrderType == 2
                    ? (this.title = '返修派工单')
                    : (this.title = '派工单')
                res.data.enumWorkOrderType == 2
                    ? (this.projectreadonly = true)
                    : (this.projectreadonly = false)
                this.form = res.data
                this.items = this.form.items
                getMaintenitemlistForDropdw({ ModelIdStr: this.form.modelId }).then(
                    (res) => {
                        res.data.pagerData.forEach((item) => {
                            item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                        })
                        this.maintainItemslist = res.data.pagerData
                        this.maintainItemslistCopy = JSON.parse(
                            JSON.stringify(res.data.pagerData)
                        )
                    }
                )
            }
            if (this.$route.query.type == '接单' && !this.$route.query.allCar) {
                this.cardisabled = true
                const OrgIds = this.jwtDecode(this.$store.state.user.partToken)
                const OrgId = OrgIds.OrgId
                const res = await teamOrgNodeId(
                    this.$route.query.id,
                    OrgId
                )
                if (res.data.entranceUrl) {
                    res.data.fileList = []
                    // const picture = res.data.entranceUrl.split(';')
                    var picture = res.data.entranceUrl.split(';').filter(function(s) {
                        return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
                    })
                    console.log(picture)
                    picture.forEach((item) => {
                        res.data.fileList.push({
                            url: item
                        })
                    })
                }
                this.resData = JSON.parse(JSON.stringify(res.data.items))
                if (res.data.items.length > 0) {
                    res.data.items.forEach((data) => {
                        data.status = true
                        data.teamNames = ''
                        if (data.workOrderMen.length > 0) {
                            data.workOrderMen.forEach((item) => {
                                data.workerNames = data.workOrderMen
                                    .map(function(obj) {
                                        return obj.workerName
                                    })
                                    .join(',')
                            })
                        }
                    })
                }
                this.form.vehicleCode = res.data.vehicleCode
                this.form.customerId = res.data.customerId
                await this.getHandList()
                console.log(this.driversColumn, res.data.drivers, '2323')

                if (this.driversColumn && this.driversColumn.length > 0) {
                    this.driversColumn.forEach((element) => {
                        res.data.drivers.forEach((items) => {
                            if (element.driverNamePhone == items) {
                                element.checked = true
                            }
                        })
                    })
                } else {
                    res.data.drivers.forEach((items) => {
                        const myObject = {
                            driverNamePhone: null,
                            checked: false
                        }
                        myObject.driverNamePhone = items
                        myObject.checked = true
                        this.driversColumn.push(myObject)
                    })
                }
                const arr = this.driversColumn.filter(function(obj) {
                    return obj.checked
                })
                res.data.driversnamephone = arr
                    .map(function(obj) {
                        return obj.driverNamePhone
                    })
                    .join(',')
                res.data.checkedDrivers = res.data.driversnamephone.split(',')
                res.data.enumMaintenanceType == 1
                    ? (res.data.enumMaintenanceName = '现场维修')
                    : (res.data.enumMaintenanceName = '场内维修')
                res.data.enumWorkOrderType == 2
                    ? (this.title = '返修派工单')
                    : (this.title = '派工单')
                this.projectreadonly = false
                this.form = res.data
                this.items = this.form.items
                getMaintenitemlistForDropdw({ ModelIdStr: this.form.modelId }).then(
                    (res) => {
                        res.data.pagerData.forEach((item) => {
                            item.text =
          item.code + '-' + item.name + '-' + item.maintenTypeName
                        })
                        this.maintainItemslist = res.data.pagerData
                        this.maintainItemslistCopy = JSON.parse(
                            JSON.stringify(res.data.pagerData)
                        )
                    }
                )
            }
            if (this.$route.query.allCar) {
                this.form.vehiclePicture = this.$route.query.photos
            }
        },
        // 取消保养提醒
        displaycancles() {
            const param = {
                maintainStatus: this.maintainStatus,
                maintenanceStatus: this.maintenanceStatus,
                vehicleId: this.form.vehicleId,
                vehicleCode: this.form.vehicleCode
            }
            displaycancle(param).then((res) => {
                if (res.isSuccess) {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                    this.centerDialogVisible = false
                }
            })
        },
        showenumFaultReasons() {
            if (this.title == '返修派工单') {
                this.enumFaultReasons = [
                    { text: '配件质量', value: 3 },
                    { text: '维修装配', value: 4 }
                ]
            } else {
                this.enumFaultReasons = [
                    { text: '自然损坏', value: 1 },
                    { text: '驾驶操作', value: 2 },
                    { text: '配件质量', value: 3 },
                    { text: '维修装配', value: 4 }
                ]
            }
            this.showenumFaultReason = true
        },
        // 项目详情
        details(item, index) {
            if (item.maintenTypeId) {
                var items = null
                for (var i = 0; i < this.maintenTypes.length; i++) {
                    if (item.maintenTypeId == this.maintenTypes[i].id) {
                        items = this.maintenTypes[i]
                    }
                }
                this.maintenTypeNamese(items)
            }

            if (this.$route.query.type == '处理') {
                this.showList = true
                console.log(this.resData[index], item.status, '项目详情')
                if (item.workOrderMen.length == 0) {
                    item.workOrderMen = [
                        { workerId: null, workerName: null, percent: null }
                    ]
                }
                this.maintainItemdetails = JSON.parse(JSON.stringify(item))
                if (item.faultOver) {
                    //this.faultOverList = [{ url: item.faultOver }]
                    let faultOvers = item.faultOver.split(';')
                    faultOvers.forEach(x=>{
                        this.faultOverList.push({ url: x })
                    })
                }
                if (item.faultPhoto) {
                    //this.faultPhotoList = [{ url: item.faultPhoto }]
                    let faultPhotos = item.faultPhoto.split(';')
                    faultPhotos.forEach(x=>{
                        this.faultPhotoList.push({ url: x })
                    })
                }
                if (item.oldNewPhoto) {
                    //this.oldNewPhotoList = [{ url: item.oldNewPhoto }]
                    let oldNewPhotos = item.oldNewPhoto.split(';')
                    oldNewPhotos.forEach(x=>{
                        this.oldNewPhotoList.push({ url: x })
                    })
                }
                this.maintainItemdetails.enumFaultReasonname = this.convertStatus(
                    this.maintainItemdetails.enumFaultReason
                )
                if (this.resData[index]) {
                    item.status && !this.resData[index].maintainItem
                        ? (this.projectreadonly = false)
                        : (this.projectreadonly = true)
                    item.status
                        ? (this.positionOrPart = true)
                        : (this.positionOrPart = false)
                } else {
                    this.projectreadonly = false
                    this.positionOrPart = false
                }
            }
        },
        activetab() {
            this.onSubmit()
        },
        // 缺件确定
        displaymplists() {
            if (this.maintenanceStatus == 1) {
                displaymplist(this.form.vehicleId).then((res) => {
                    res.data.forEach((item) => {
                        if (item.workOrderMen.length == 0) {
                            item.workOrderMen = [
                                { workerId: null, workerName: null, percent: null }
                            ]
                        }
                    })
                    this.form.items = res.data
                    this.centerDialogVisible = false
                })
            } else {
                this.centerDialogVisible = false
            }
        },
        // 点击删除
        delImg(what, whatList,index) {
            if (isNaN(index) || index >= this[`${whatList}`].length) {
                return false
            }
            console.log(this.photoList)
            //this.maintainItemdetails[`${what}`] = ''
            //this[`${whatList}`] = [] 
            this[`${whatList}`].splice(index, 1)
            if (this[`${whatList}`].length > 0) {
                this.maintainItemdetails[`${what}`] = ''
                this[`${whatList}`].forEach((item) => {
                    this.maintainItemdetails[`${what}`] = this.maintainItemdetails[`${what}`].concat(item.url + ';')
                })
                
                this.maintainItemdetails[`${what}`] = this.maintainItemdetails[`${what}`].slice(0, -1)
            } else {
                this.maintainItemdetails[`${what}`] = ''
            }
            return
        },
        // 点击的时候调用相机
        clicktotakephotos(val) {
            const obj = {
                url: process.env.VUE_APP_IMG + val
            }
            this[`${this.photoList}`].push(obj)
            //this.maintainItemdetails[`${this.photo}`] = process.env.VUE_APP_IMG + val
            if(this.maintainItemdetails[`${this.photo}`] != '' && this.maintainItemdetails[`${this.photo}`] != null){
                this.maintainItemdetails[`${this.photo}`] = this.maintainItemdetails[`${this.photo}`] + ';' + process.env.VUE_APP_IMG + val
            } else {
                this.maintainItemdetails[`${this.photo}`] = process.env.VUE_APP_IMG + val 
            }
        },
        //拍照相册确认
        photographs(faultPhoto, faultPhotoList){
            this.photo = faultPhoto
            this.photoList = faultPhotoList
            const data = this.moment().format('YYYY-MM-DD HH:mm:ss')
            let gw = ''
            if (this.form.items.length > 0) {
                gw = this.form.items[0].stationName
            }
            const code = this.form.vehicleCode
            const str = gw ? `${data},,${gw},,${code}` : `${data},,${code}`
            window.test.openCamera(str)
            if(faultPhoto=='faultPhoto'){
                this.showworkses=false
            }else if(faultPhoto=='oldNewPhoto'){
                this.oldandnew=false
            }else if(faultPhoto=='faultOver'){
                this.faultcompletion=false
            }
        },
        clicktotakephotose() {
            this.showworkses = true
        },
        oldandnews() {
            this.oldandnew = true
        },
        faultcompletions() {
            this.faultcompletion = true
        },
        // 提交
        submit(type) {
            if (this.form.items.length == 0) {
                Toast.fail('请添加维修项目数据')
                return
            }
            // let photo = false
            // this.form.items.forEach(item=>{
            //     if((!item.faultPhoto || !item.oldNewPhoto || !item.faultOver)&&this.$route.query.type == '处理'){
            //         photo = true
            //     }else{
            //         photo = false
            //     }
            // })
            // if (photo) {
            //     Toast.fail('照片必填')
            //     return
            // }
            // let count = 0
            // if (this.form.items) {
            //     this.form.items.forEach(item => {
            //         if (!item.maintenItemId) {
            //             count++
            //         }
            //     })
            // }
            // if (count) {
            //     Toast.fail('维修项目不支持手动录入')
            //     return
            // }
            // console.log(11111,this.$route.query.type)
            if (
                !this.$route.query.type ||
                this.$route.query.type == '返修派工单' ||
                this.$route.query.type == '入场处理'
            ) {
                this.form.sheetNo = this.sheetNos
                this.form.id = uuid()
            }
            this.form.items &&
            this.form.items.forEach((item) => {
                item.workOrderMen = item.workOrderMen.filter((items) => {
                    return items.workerId
                })
            })
            console.log('提交信息', this.form)
            let maintainItem = false
            let work = false

            this.form.items &&
            this.form.items.forEach((item) => {
                if (!item.maintainItem) {
                    maintainItem = true
                }
                if (item.workOrderMen.length == 0) {
                    work = true
                }

                item.workOrderMen.forEach((ite) => {
                    if (!ite.workerId || !ite.percent) {
                        work = true
                    }
                })
            })
            if (maintainItem) {
                Toast.fail('维修项目必填')
                return
            }
            // if (work) {
            //     Toast.fail('维修工，权责不能为空')
            //     return
            // }
            workOrderDispatch(this.form).then((res) => {
                if (res.code === 200) {
                    if (this.form.isNotMaintain) {
                        this.form.items.forEach((item) => {
                            item.statementMen = item.workOrderMen
                            item.enumQualityInspectionResult = 2
                        })
                        qualityCheckSubmit(this.form).then((res) => {
                            if (res.isSuccess) {
                                // 提交成功
                                if (type == 2) {
                                    WorkOrdercommitQC(this.form).then((res) => {
                                        if (res.code === 200) {
                                            Toast.success(res.message)
                                            this.$router.push({ path: '/workorderlistsearch' })
                                        } else {
                                            this.$toast({
                                                message: res.message,
                                                duration: 2000,
                                                onClose: () => {
                                                    // Toast 关闭后重新加载
                                                    console.log('开始重新加载页面')
                                                    location.reload()
                                                }
                                            })
                                        }
                                    })
                                } else {
                                    Toast.success('提交成功')
                                    this.$router.push({ path: '/workorderlistsearch' })
                                }

                            } else {
                                Toast.success(res.message)
                            }
                        })
                    } else {
                        if (type == 2) {
                            WorkOrdercommitQC(this.form).then((res) => {
                                if (res.code === 200) {
                                    Toast.success(res.message)
                                    this.$router.push({ path: '/workorderlistsearch' })
                                } else {
                                    this.$toast({
                                        message: res.message,
                                        duration: 2000,
                                        onClose: () => {
                                            // Toast 关闭后重新加载
                                            console.log('开始重新加载页面')
                                            location.reload()
                                        }
                                    })
                                }
                            })
                        } else {
                            Toast.success('提交成功')
                            this.$router.push({ path: '/workorderlistsearch' })
                        }
                    }
                }
            })
        },
        // 接单
        submits() {
            Dialog.confirm({
                title: '确认接单',
                message: '是否确认接单？'
            })
                .then(() => {
                    this.visitSelectDate(new Date())
                    const shifhou = {
                        Id: this.$route.query.id, // 派工单id
                        confirm: true,
                        confirmName: this.$store.state.user.userInfo.nickName,
                        confirmTime: this.ConfirmTime
                    }
                    console.log(this.$store.state.user.userInfo)
                    qualityCheckSubmits(shifhou).then((res) => {
                        if (res.isSuccess) {
                            // 提交成功
                            Toast.success('接单成功')
                            window.open(
                                '/workorderlistsearchdetail?id=' +
            this.$route.query.id +
            '&type=处理&activeName=b',
                                '_self'
                            )
                            // window.close();
                            //  this.$router.push({
                            //     path: '/workorderlistsearchdetail',
                            //     query:{
                            //         id:this.$route.query.id,
                            //         type:'处理'
                            //     }
                            // })
                        } else {
                            Toast.success(res.message)
                        }
                    })
                })
                .catch(() => {
                    // on cancel
                })
        },
        // 暂存
        zancun() {
            if (
                !this.$route.query.type ||
          this.$route.query.type == '返修派工单' ||
          this.$route.query.type == '入场处理'
            ) {
                this.form.sheetNo = this.sheetNos
                this.form.id = uuid()
            }
            this.form.items &&
          this.form.items.forEach((item) => {
              item.workOrderMen = item.workOrderMen.filter((items) => {
                  return items.workerId
              })
          })
            WorkOrdertempSave(this.form).then((res) => {
                console.log(res)
                if (res.isSuccess) {
                    Toast(res.message)
                    this.$router.push({ path: '/dispatching' })
                }
            })
            console.log(this.form)
        },
        PrefixInteger(num, length) {
            return (Array(length).join('0') + num).slice(-length)
        },
        // 生成单号
        getOdd() {
            let tenantCode = null
            if (!this.$store.state.user.userInfo.tenantId) {
                tenantCode = '0000'
            } else {
                tenantCode = this.PrefixInteger(this.$store.state.user.userInfo.tenantId, 4)
            }
            var sheetNo = `PG${
                tenantCode
            }${moment().format('YYYY')}${moment().format('MM')}${moment().format(
                'DD'
            )}`
            getOdd(sheetNo).then((res) => {
                if (res.isSuccess) {
                    this.sheetNos = res.data.sheetNo
                    console.log(res.data, '单号')
                }
            })
        },
        // 维修队筛选
        async teamlist() {
            // if (this.projectreadonly) {
            //     this.showteam = false
            //     return
            // }
            // if (this.projectreadonly) {
            //     this.showteam = true
            // }

            const res = await displayteam(this.maintainItemdetails.maintainItemId)
            res.data.pagerData.forEach((item) => {
                item.text = item.teamName
            })
            this.teamNames = res.data.pagerData
            // this.showteam = true
        },
        // // 获取工时单价
        // setParameters() {
        //     setParameter({ OrgId: this.companyId }).then(res => {
        //         if (res.code === 200) {
        //             this.unitPrice = res.data.WorkHourPrice || 0
        //             this.maintainItemdetails.unitPrice = res.data.WorkHourPrice || 0
        //         }
        //     })
        // },
        // 部件列表
        bwpart() {
            if (this.title == '返修派工单') {
                this.showpart = false
                return
            }
            if (this.positionOrPart) {
                this.showpart = false
                return
            }
            if (this.form.isNotMaintain) {
                this.showpart = false
                return
            }
            if (this.form.isOnlyRequisitionPart) {
                this.showpart = false
                return
            }
            if (!this.positionOrPart) {
                this.showpart = true
            }
            // 部件列表
            getVehiclepositList({
                positionsName: [this.maintainItemdetails.position],
                partName: '',
                startTime: '',
                endTime: '',
                PageSize: 10000,
                PageIndex: 1,
                allData: 2
            }).then((res) => {
                if (res.data) {
                    res.data.pagerData.forEach((item) => {
                        item.text = item.partName
                    })
                    this.parts = res.data.pagerData
                    this.showpart = true
                } else {
                    this.parts = []
                    this.showpart = false
                }
            })
        },
        // 确认故障原因
        confirmenumFaultReason(val) {
            console.log(val)
            this.enumFaultReasons.forEach((res) => {
                if (res.text == val.text) {
                    this.maintainItemdetails.enumFaultReason = res.value
                    this.maintainItemdetails.enumFaultReasonname = res.text
                    this.showenumFaultReason = false
                }
                // if(val.text)
            })

            if (
                (val.text == '配件质量' || val.text == '维修装配') &&
  this.title != '返修派工单'
            ) {
                this.equiTimingRunVisible = true
                // this.showList = false
                WorkOrderhistoryList({
                    vehicleId: this.form.vehicleId,
                    maintainItemId: this.maintainItemdetails.maintainItemId,
                    partId: null
                }).then((res) => {
                    this.modalObj.tableData = res.data
                })
            }
        },
        // 维修队确认
        confirmteam(val) {
            console.log(val)
            this.teamNames.forEach((res) => {
                if (res.teamId == val.teamId) {
                    this.maintainItemdetails.teamName = res.teamName
                    this.maintainItemdetails.teamId = res.teamId
                    this.maintainItemdetails.workOrderMen.forEach((element) => {
                        element.workerId = null
                        element.workerName = null
                        element.percent = null
                    })
                    this.maintainItemdetails.teamOrgNodeId = res.orgNodeId
                    this.showteam = false
                }
            })
        },
        // 获取维修工
        async getWorkers(val) {
            console.log(val)
            this.index = val
            const res = await GetworkerByMtId({
                MaintenanceTeamID: this.maintainItemdetails.teamId
            })
            if (res.isSuccess) {
                res.data &&
    res.data.forEach((item) => {
        item.text = item.workerName
    })
            }
            if (res.data.length == 0) {
                return
            }
            this.workers = res.data
            this.showwork = true
        },
        // 点击维修工加号
        // addWorkOrder() {
        //     this.maintainItemdetails.workOrderMen.push({ workerName: '', percent: '', deltBtn: '-' })
        // },
        // 确认部位
        confirmposition(val) {
            this.positions.forEach((res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.position = res.name
                    this.showpositions = false
                }
            })
        },
        // 点击减号删除
        deltWorkOrder(index) {
            this.maintainItemdetails.workOrderMen.splice(index, 1)
        },

        // 维修工确认确认
        confirmwork(event) {
            const { text, id } = event
            this.maintainItemdetails.workOrderMen[this.index].workerName = text
            this.maintainItemdetails.workOrderMen[this.index].workerId = id
            if (this.maintainItemdetails.workOrderMen.length == 1) {
                this.maintainItemdetails.workOrderMen[0].percent = 100
            }
            this.showwork = false
        },
        // 确认部件
        confirmpart(val) {
            this.parts.forEach((res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.part = res.partName
                    this.maintainItemdetails.partId = res.id
                    this.showpart = false
                }
            })
        },
        // 维修项目列表
        showLists() {
            this.maintainItemName = '添加项目'
            this.showList = true
            this.projectreadonly = false
            this.positionOrPart = false
            this.maintainItemdetails.id = uuid()
            this.maintainItemdetails.teamName =
  this.form.items && this.items[0].teamName
            this.maintainItemdetails.maintenTypeName =
  this.form.items && this.items[0].maintenTypeName
            this.maintainItemdetails.stationName =
  this.form.items && this.items[0].stationName
            this.maintainItemdetails.stationId =
  this.form.items && this.items[0].stationId
            this.maintainItemdetails.teamId = this.form.items && this.items[0].teamId
            this.maintainItemdetails.teamOrgNodeId =
  this.form.items && this.items[0].teamOrgNodeId
            this.maintainItemdetails.enumFaultReasonname = '自然损坏'
            this.maintainItemdetails.enumFaultReason = 1
            console.log(this.maintenTypes, this.maintainItemdetails, 'this.maintenTypes')
            if (this.form.items[0].maintenTypeId) {
                var items = null
                for (var i = 0; i < this.maintenTypes.length; i++) {
                    if (this.form.items[0].maintenTypeId == this.maintenTypes[i].id) {
                        items = this.maintenTypes[i]
                    }
                }
                this.maintenTypeNamese(items)
            }
            // if(item.maintenTypeId){
            //     var items=null
            //     for(var i=0;i<this.maintenTypes.length;i++){
            //         if(item.maintenTypeId==this.maintenTypes[i].id){
            //             items=this.maintenTypes[i]
            //         }
            //     }
            //     this.maintenTypeNamese(items)
            // }
        },
        // 清空车辆编号
        closepopup() {
            if (!this.num) {
                this.form.vehicleCode = null
            }
        },
        // 先选车辆才有驾驶员
        async showdriver() {
            if (!this.form.vehicleCode) {
                Toast('请先选择车辆')
            } else if (
                this.form.enumWorkOrderStatus != 1 ||
  this.title == '返修派工单'
            ) {
                return
            } else {
                // if (!this.form.driversnamephone) {
                //     await this.getHandList()
                // }
                if (this.driversColumn.length == 0) {
                    this.showdrivers = false
                } else {
                    this.showdrivers = true
                }
            }
        },
        // 选择驾驶员
        toggle(item, index) {
            console.log(this.driversColumn, index)
            if (item.checked == false) {
                console.log(this.$refs.checkboxes.length)
                item.checked = true
                this.$refs.checkboxes[index].toggle()
            } else {
                console.log(1111)
                item.checked = false
                this.$refs.checkboxes[index].toggle()
            }
            const arr = this.driversColumn.filter(function(obj) {
                return obj.checked
            })
            this.form.driversnamephone = arr
                .map(function(obj) {
                    return obj.driverNamePhone
                })
                .join(',')
            this.form.drivers = this.form.driversnamephone.split(',')
            console.log(this.driversColumn, '121212')
        },
        // 驾驶员下拉
        async getHandList() {
            if (!this.form.customerId) {
                this.driversColumn = []
                return
            }
            const param = {
                PageIndex: 1,
                PageSize: 10000,
                customerId: this.form.customerId
            }
            this.form.driver = null
            await getDriverList(param).then((res) => {
                if (res.isSuccess) {
                    res.data.pagerData.forEach((item) => {
                        item.driverNamePhone = item.name + '-' + item.contactNo
                        item.checked = false
                    })
                    this.driversColumn = res.data.pagerData
                }
            })
        },
        onConfirm(val) {
            this.num = val
            console.log(val, this.vehicleCodeColumn)
            const res = this.vehicleCodeList.filter((item) => {
                return item.code == val
            })
            this.form.outStockType = res[0].outStockType
            this.form.customerId = res[0].customerId

            getCarDetails(res[0].id).then(async(res) => {
                this.carid = val
                await this.getHandList()
                this.form.category = res.data.machineCategoryName
                this.form.barCode = res.data.barCode
                this.form.owner = res.data.ownerNames
                // if (res.data.vehicleDrivers) {
                //     res.data.vehicleDrivers.forEach(item => {
                //         item.driverNamePhone = item.driverName + '-' + item.driverPhone
                //         this.form.checkedDrivers.push(item.driverName + '-' + item.driverPhone)
                //     })
                //     this.form.driversnamephone = res.data.vehicleDrivers.map(function(obj) {
                //         return obj.driverNamePhone
                //     }).join(',')
                //     this.form.drivers = this.form.driversnamephone.split(',')
                //     this.driversColumn.forEach(element => {
                //         this.form.driversnamephone.split(',').forEach(items => {
                //             if (element.driverNamePhone == items) {
                //                 element.checked = true
                //             }
                //         })
                //     })
                // } else {
                //     this.form.checkedDrivers = []
                // }
                this.form.modelId = res.data.machineModelId
                this.form.machineModelId = res.data.machineModelId
                this.form.vehicleCode = res.data.code
                this.form.customer = res.data.customerName
                this.form.brand = res.data.machineBrandName
                this.form.model = res.data.machineModel
                // this.form.driver = res.data.driverName
                this.form.driverPhone = res.data.driverPhone
                this.form.vehicleId = res.data.id
                this.form.phone = null
                // if (!res.data.barCode) {
                //     this.$message({
                //         message: '请先维护该车辆档案的条码编号',
                //         type: 'error'
                //     })
                // }
                this.displayreminders(this.form.vehicleId)
                this.showpicker = false
            })
        },
        // 保养提醒
        displayreminders(vehicleId) {
            displayreminder(vehicleId).then((res) => {
                if (res.data) {
                    this.maintainStatus = res.data.maintainStatus
                    this.maintenanceStatus = res.data.maintenanceStatus
                    this.maintainMessage = res.data.maintainMessage
                }
            })
        },
        // 根据车辆变化查询
        queryvehicleCode() {
            //  Toast(1);
            // var data={};
            // data.code=this.vehicleCode;
            this.num = null
            this.vehicleCodeColumn = []
            var refData = []
            if (!this.form.vehicleCode) {
                return
            }
            getvehicleCodeList(this.form.vehicleCode).then((res) => {
                if (res.code == 200) {
                    this.vehicleCodeList = res.data
                    if (this.vehicleCodeList.length > 0) {
                        var i = 0
                        for (i; i < this.vehicleCodeList.length; i++) {
                            refData[i] = this.vehicleCodeList[i].code
                        }
                    }
                    this.vehicleCodeColumn = refData
                    this.showpicker = true
                    // Notify({ type: 'success', message: this.vehicleCodeList.length });
                } else {
                    Toast(res.message)
                }
            })
        },
        // 条码编号搜索
        querybarCode() {
            //  Toast(1);
            // var data={};
            // data.code=this.vehicleCode;
            this.barCodeColumn = []
            var refData = []

            getbarCodeList(this.form.barCode).then((res) => {
                if (res.code == 200) {
                    this.barCodeList = res.data
                    console.log(this.barCodeList)
                    if (this.barCodeList.length > 0) {
                        var i = 0
                        for (i; i < this.barCodeList.length; i++) {
                            refData[i] = this.barCodeList[i].barCode
                        }
                    }
                    this.barCodeColumn = refData
                    this.showbarCode = true
                    // Notify({ type: 'success', message: this.vehicleCodeList.length });
                } else {
                    Toast(res.message)
                }
            })
        },
        // 条码编号确认
        barcodeConfirm(val) {
            this.num = val
            console.log(val, this.barCodeColumn)
            const res = this.barCodeList.filter((item) => {
                return item.barCode == val
            })
            console.log(111111, res)
            this.form.outStockType = res[0].outStockType
            this.form.customerId = res[0].customerId

            getvehicleInfoItem(res[0].id).then(async(res) => {
                this.carid = val
                await this.getHandList()
                this.form.category = res.data.machineCategoryName
                this.form.barCode = res.data.barCode
                this.form.owner = res.data.ownerNames
                this.form.modelId = res.data.machineModelId
                this.form.machineModelId = res.data.machineModelId
                this.form.vehicleCode = res.data.code
                this.form.customer = res.data.customerName
                this.form.brand = res.data.machineBrandName
                this.form.model = res.data.machineModel
                // this.form.driver = res.data.driverName
                this.form.driverPhone = res.data.driverPhone
                this.form.vehicleId = res.data.id
                this.form.phone = null
                this.displayreminders(this.form.vehicleId)
                this.showbarCode = false
            })
        },
        clearbarCode() {
            console.log('clearvehicleCode')
            this.form.barCode = ''
        },
        clearvehicleCode() {
            console.log('clearvehicleCode')
            this.form.vehicleCode = ''
        },
        // 维修项目模糊搜索
        async queryMaintainItem() {
            if (this.maintainItemdetails.maintainItem) {
                const res = await getMaintenitemlistForDropdw({
                    keywords: this.maintainItemdetails.maintainItem,
                    ModelIdStr: this.form.modelId,
                    beginDate: '',
                    endDate: '',
                    maintenTypeIds: this.maintainItemdetails.maintenTypeId
                        ? [this.maintainItemdetails.maintenTypeId]
                        : [],
                    PageSize: 20,
                    PageIndex: 1
                })
                res.data.pagerData.forEach((item) => {
                    item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                })
                var authorityadmin = res.data.pagerData.filter(
                    (itmer) =>
                        itmer.text.indexOf(this.maintainItemdetails.maintainItem) === -1
                )
                if (authorityadmin.length == 0) {
                    this.maintainItemslist = res.data.pagerData
                    // this.maintainItemslistCopy = JSON.parse(JSON.stringify(res.data.pagerData || []))
                }
                // this.maintainItemslist = res.data.pagerData
            } else {
                const res = await getMaintenitemlistForDropdw({
                    keywords: '',
                    ModelIdStr: this.form.modelId,
                    beginDate: '',
                    endDate: '',
                    maintenTypeIds: this.maintainItemdetails.maintenTypeId
                        ? [this.maintainItemdetails.maintenTypeId]
                        : [],
                    PageSize: 20,
                    PageIndex: 1
                })
                res.data.pagerData.forEach((item) => {
                    item.text = item.code + '-' + item.name + '-' + item.maintenTypeName
                })
                this.maintainItemslist = res.data.pagerData
            }
            console.log('维修项目', this.maintainItemslist.length)
            if (this.maintainItemslist.length == 0) {
                this.maintainItemdetails.maintainItemId = null
                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.unitPrice = null
                this.maintainItemdetails.maintainItemNum = null
            }
        },
        // 维修项目失焦
        blurMaintainItem(val) {
            let arr = []
            console.log(1111111111111111)
            if (!this.projectreadonly && val) {
                arr = this.maintainItemslistCopy.filter((item) => {
                    return item.name == val
                })
                console.log('ddddddd', arr)
                if (arr.length == 0) {
                    this.maintainItemdetails.maintainItem = null
                }
            }
        },
        // 确认维修项目
        confirmmaintainItem(val) {
            console.log(val)
            this.maintainItemdetails.maintainType = val.maintainType
            this.maintainItemslist.forEach(async(res) => {
                if (res.id == val.id) {
                    this.maintainItemdetails.maintainType = val.maintainType
                    this.maintainItemdetails.enumMaintenType = res.enumMaintenType
                    this.maintainItemdetails.maintainItem =
      res.code + '-' + res.name + '-' + res.maintenTypeName
                    this.maintainItemdetails.maintainItemId = res.id
                    this.showmaintainItems = false
                    this.maintainItemdetails.workHour = res.hours
                    this.maintainItemdetails.unitPrice = res.price
                    // await queryhours({ maintenItemId: res.id, modelId: this.form.modelId || this.form.machineModelId }).then(res => {
                    //     if (res.data) {
                    //         this.maintainItemdetails.workHour = res.data.hours
                    //         this.maintainItemdetails.unitPrice = res.data.price
                    //     } else {
                    //         this.maintainItemdetails.workHour = null
                    //         this.maintainItemdetails.unitPrice = null
                    //     }
                    //     this.maintainItemdetails.maintainItemNum = null
                    // })
                }
            })
            // if (val) {
            //     this.projectreadonly = true
            //     // this.unitpricereadonly = true
            // } else {
            //     this.projectreadonly = false
            //     // this.unitpricereadonly = false
            // }
        },
        // 驾驶员下拉
        async queryDrivers() {
            if (this.form.enumWorkOrderStatus == 1) {
                this.showdrivers = true
            } else {
                this.showdrivers = false
                return
            }
            this.driversColumn = []
            if (!this.form.customerId) {
                this.driversColumn = []
                return
            }
            const param = {
                PageIndex: 1,
                PageSize: 10000,
                customerId: this.form.customerId
            }
            this.form.driver = null
            await getDriverList(param).then((res) => {
                if (res.isSuccess) {
                    res.data.pagerData.forEach((item) => {
                        item.driverNamePhone = item.name + '-' + item.contactNo
                        item.checked = false
                    })
                    this.driversColumn = res.data.pagerData
                    if (this.driversColumn) {
                        this.driversColumn.forEach((element) => {
                            this.form.driversnamephone.split(',').forEach((items) => {
                                if (element.driverNamePhone == items) {
                                    element.checked = true
                                }
                            })
                        })
                    } else {
                        this.form.checkedDrivers = []
                    }
                }
            })
        },
        closeshowList() {
            this.maintainItemdetails.faultPhoto = '',
            this.maintainItemdetails.faultOver = '',
            this.maintainItemdetails.oldNewPhoto = '',
            this.faultPhotoList = [],
            this.faultOverList = [],
            this.oldNewPhotoList = [],
            this.maintainItemdetails.maintainItemNum = null
            this.maintainItemdetails.workHour = null
            this.maintainItemdetails.position = null
            this.maintainItemdetails.part = null
            this.maintainItemdetails.teamName = null
            this.maintainItemdetails.maintainItem = null
            this.maintainItemdetails.partId = null
            this.maintainItemdetails.maintainItemId = null
            this.maintainItemdetails.unitPrice = null
            this.maintainItemdetails.workerNames = null
            this.maintainItemdetails.workHour = null
            this.maintainItemdetails.enumFaultReasonname = null
            this.maintainItemdetails.enumFaultReason = null
            this.maintainItemdetails.totalPrice = 0
            this.maintainItemdetails.workOrderMen = [
                { workerId: null, workerName: null, percent: null }
            ]
            this.projectreadonly = false
        },
        async onSubmits(val) {
            debugger
            if (val) {
                this.maintainItemdetails.pictures = this.fileLists
                this.maintainItemdetails.workOrderMen =
    this.maintainItemdetails.workOrderMen.filter((item) => {
        return item.workerId
    })
                this.maintainItemdetails.workerNames =
    this.maintainItemdetails.workOrderMen
        .map(function(obj) {
            return obj.workerName
        })
        .join(',')
                console.log(this.maintainItemdetails.id, 234923)
                // this.form.items.forEach(res => {
                //     if (res.id == this.maintainItemdetails.id) {
                //         res = this.maintainItemdetails
                //     } else {
                //         this.form.items.push(JSON.parse(JSON.stringify(this.maintainItemdetails)))
                //     }
                // })
                let index = ''
                for (let i = 0; i < this.form.items.length; i++) {
                    if (this.maintainItemdetails.id == this.form.items[i].id) {
                        index = i
                    }
                }
                console.log('位置', index)
                this.maintainItemdetails.workOrderId = this.form.id
                if (
                    this.form.items.findIndex(
                        (item) => item.id === this.maintainItemdetails.id
                    ) > -1
                ) {
                    await this.form.items.splice(
                        this.form.items.findIndex(
                            (item) => item.id === this.maintainItemdetails.id
                        ),
                        1
                    )
                    // this.form.items.push(JSON.parse(JSON.stringify(this.maintainItemdetails)))
                    this.form.items.splice(
                        index,
                        0,
                        JSON.parse(JSON.stringify(this.maintainItemdetails))
                    )
                } else {
                    this.form.items.push(
                        JSON.parse(JSON.stringify(this.maintainItemdetails))
                    )
                }
                // this.form.items.findIndex(item => item.id === this.maintainItemdetails.id)
                // console.log(this.form.items.findIndex(item => item.id === this.maintainItemdetails.id))
                // await this.form.items.splice(this.form.items.findIndex(item => item.id === this.maintainItemdetails.id), 1)
                // console.log(this.form.items)
                // this.form.items.push(JSON.parse(JSON.stringify(this.maintainItemdetails)))
                this.maintainItemdetails.faultPhoto = null
                this.maintainItemdetails.oldNewPhoto = null
                this.maintainItemdetails.faultOver = null
                this.faultPhotoList = [],
                this.oldNewPhotoList = []
                this.faultOverList = []
                this.maintainItemdetails.maintainItemNum = null
                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.position = null
                this.maintainItemdetails.part = null
                this.maintainItemdetails.teamName = null
                this.maintainItemdetails.maintainItem = null
                this.maintainItemdetails.partId = null
                this.maintainItemdetails.maintainItemId = null
                this.maintainItemdetails.unitPrice = null

                this.maintainItemdetails.workHour = null
                this.maintainItemdetails.workerNames = null
                this.maintainItemdetails.enumFaultReasonname = null
                this.maintainItemdetails.enumFaultReason = null
                this.maintainItemdetails.totalPrice = 0
                this.maintainItemdetails.workOrderMen = [
                    { workerId: null, workerName: null, percent: null }
                ]

                this.showList = false
            }
        },
        onSubmit(values) {
            console.log(values)
            if (values) {
                console.log(this.form)

                // if (!values['驾驶员']) {
                //     Toast.fail('请先维护车辆档案的驾驶员')
                //     return
                // }
                if (this.form.drivers && this.form.drivers.length > 2) {
                    Toast.fail('最多绑定两个驾驶员')
                    return
                }
                // if (!this.form.owner) {
                //     Toast.fail('请先维护车辆档案的权责人')
                //     return
                // }

                this.tabdisabled = false
                this.jbinfo = values
                this.$nextTick(() => {
                    this.activeName = 'b'
                })
            }
        },
        routeto() {
            this.$router.push({
                path: '/partsrepair',
                query: { keyword: this.form.barCode }
            })
        },
        routetos() {
            let gw = ''
            if (this.form.items.length > 0) {
                gw = this.form.items[0].stationName
            }
            this.$router.push({
                path: '/partsrepairse',
                query: {
                    id: this.form.id,
                    gw: gw,
                    vehicleCode: this.form.vehicleCode,
                    photos: this.form.vehiclePicture,
                    type: this.$route.query.type,
                    status: this.$route.query.status
                }
            })
        },
        // routetos() {
        //   this.$router.push({
        //     path: '/partsrepairs',
        //     query: {
        //       id: this.form.id,
        //       photos: this.form.vehiclePicture,
        //       type: this.$route.query.type,
        //     },
        //   })
        // },
        getBack() {
            this.$router.push({ path: '/workorderlistsearch' })
        },
        convertStatus(status) {
            switch (status) {
            case 1:
                return '自然损坏'
            case 2:
                return '驾驶操作'
            case 3:
                return '配件质量'
            case 4:
                return '维修装配'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.icon-style .van-icon {
  margin-top: 0.23rem;
}
.info-span-bottom {
  display: inline-block;
  padding: 0px 8px;
  color: #000;
  width: 46%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
